import { SVGProps, Ref, forwardRef } from 'react';

export const ClocheOutlinedSize24Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M13.75 1a1.15 1.15 0 0 1 0 2.3h-.85v3.916c2.951.1 5.398.72 7.012 2.277 1.822 1.756 2.347 4.456 1.777 8.08-.332 2.114.202 2.936.55 3.258a1.45 1.45 0 0 0 .759.365l.027.003H24V23H0v-1.8h.975l.027-.004a1.451 1.451 0 0 0 .759-.365c.348-.322.882-1.144.55-3.259-.57-3.623-.045-6.323 1.777-8.079 1.614-1.556 4.06-2.177 7.012-2.277V3.3h-.85a1.15 1.15 0 0 1-1.145-1.033L9.1 2.15l.005-.117A1.15 1.15 0 0 1 10.25 1zM12 9c-3.246 0-5.414.585-6.663 1.79-1.203 1.16-1.779 3.127-1.248 6.503.274 1.745.077 3.01-.387 3.906h16.596c-.464-.897-.661-2.161-.387-3.906.53-3.377-.045-5.344-1.248-6.504C17.413 9.585 15.246 9 12 9"
            fill="currentColor"
        />
    </svg>
));
ClocheOutlinedSize24Glyph.displayName = 'ClocheOutlinedSize24Glyph';
